//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faArrowCircleDown, faArrowLeft } from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'BrandHero',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      faArrowCircleDown,
      faArrowLeft,
    };
  },
};
